import { Transforms } from 'slate';

import types from '../../elements/types';

const listTypes = [
  types.NUMBERED_LIST,
  types.BULLETED_LIST
];
// eslint-disable-next-line func-style
const withEmptyListCleanup = editor => {
  const { normalizeNode } = editor;

  editor.normalizeNode = entry => {
    const [node, path] = entry;
    // Check if the node is a "bulleted-list" and if it has an empty children array
    if (listTypes.includes(node.type) && (!node.children || node.children.length === 0)) {
      Transforms.removeNodes(editor, { at: path });
      return;
    }

    // Proceed with normal node normalization
    normalizeNode(entry);
  };

  return editor;
};

export default withEmptyListCleanup;